let initialState = {
  notifications: [],
};

let defaultNotification = {
  type: 'info', // 'info', 'success', 'warning', 'error'
  message: '',
  border: 'left', // 'left', 'right', 'top', 'bottom'
  timeout: 3500,
  dismissible: true,
  elevation: 6,
  icon: undefined,
};

export default {
  state: () => initialState,
  mutations: {
    ADD_NOTIFICATION(state, notification) {
      const id = Date.now().toString();
      const finalNotification = {...defaultNotification, ...notification, id}; // setting standard values and id

      state.notifications.push(finalNotification);

      setTimeout(() => {
        state.notifications = state.notifications.filter(a => a.id !== id);
      }, finalNotification.timeout);
    },
    REMOVE_NOTIFICATION(state, id) {
      state.notifications = state.notifications.filter(notification => notification.id !== id);
    },
    TRUNCATE_NOTIFICATIONS(state) {
      state.notifications = [];
    },
    RESET_NOTIFICATIONS(state) {
      const s = initialState;
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    }
  },
  actions: {
    addNotification({commit}, notification) {
      commit('ADD_NOTIFICATION', notification);
    },
    removeNotification({commit}, id) {
      commit('REMOVE_NOTIFICATION', id);
    },
    truncateNotifications({commit}) {
      commit('TRUNCATE_NOTIFICATIONS');
    },
    resetNotifications({commit}) {
      commit('RESET_NOTIFICATIONS');
    }
  },
  getters: {
    notifications: state => state.notifications
  }
};
